import { useEffect, useId, useRef, useState, type ReactNode } from 'react';
import { CaretDown } from '@phosphor-icons/react';

/** Desktop tools remain visible; phone users reveal them when needed. */
export function MobileDisclosure({ title, description, resetKey = '', className = '', children }: {
  title: string;
  description?: string;
  resetKey?: string;
  className?: string;
  children: ReactNode;
}) {
  const id = useId();
  const button = useRef<HTMLButtonElement>(null);
  const content = useRef<HTMLDivElement>(null);
  const [expanded, setExpanded] = useState({ key: resetKey, open: false });
  const open = expanded.key === resetKey && expanded.open;
  useEffect(() => {
    if (!open && content.current?.contains(document.activeElement)
      && window.matchMedia?.('(max-width: 720px)').matches) button.current?.focus();
  }, [open]);
  return <div className={`mobile-disclosure ${className}${open ? ' is-open' : ''}`}>
    <button ref={button} type="button" className="mobile-disclosure__toggle" aria-expanded={open} aria-controls={id}
      onClick={() => setExpanded({ key: resetKey, open: !open })}>
      <span><b>{title}</b>{description && <small>{description}</small>}</span>
      <CaretDown aria-hidden="true" />
    </button>
    <div ref={content} id={id} className="mobile-disclosure__content">{children}</div>
  </div>;
}
